import React from "react";
import { useAppSelector } from "../../../../../../../redux";
import {
  Iconography,
  IconographySizes,
  Loader,
  LoaderSizes,
  Pagination,
  Toggle,
} from "@hid-galaxy-ui/galaxy-react";
import ContractCard from "../../../../../../../common/components/ContractCard";
import "./TabContentServiceContract.scss";

const TabContentServiceContract: React.FC<{
  collectionKey: string;
}> = ({ collectionKey }) => {
  const [contractState, setContractState] = React.useState({
    filteredServiceContract: [],
  });
  const [currentPageNumber, setCurrentPageNumber] = React.useState<number>(1);
  const [showActiveOnly, setShowActiveOnly] = React.useState<boolean>(false);
  const { contracts, status } = useAppSelector((state) => state.my_account);

  React.useEffect(() => {
    let filteredServiceContract = contracts.filter(
      (contract) =>
        contract.collection?.trim().toLowerCase().replaceAll(" ", "_") ===
        collectionKey
    );

    if (showActiveOnly) {
      filteredServiceContract = filteredServiceContract.filter(
        (contract) => contract.status === "Active"
      );
    }

    setContractState({
      filteredServiceContract: filteredServiceContract,
    });
  }, [contracts, collectionKey, showActiveOnly]);

  React.useEffect(() => {
    setCurrentPageNumber(1);
  }, [collectionKey, showActiveOnly]);

  const handleToggleChange = (e: any) => {
    setShowActiveOnly(e.target.checked);
  };

  const pageSize = 5;
  const totalRecords = contractState.filteredServiceContract.length;

  const handlePageChange = (clickedPageNumber: number | null) => {
    setCurrentPageNumber(clickedPageNumber);
  };

  const paginatedData = contractState.filteredServiceContract.slice(
    (currentPageNumber - 1) * pageSize,
    currentPageNumber * pageSize
  );

  return (
    <div className="tab-content-partner-services">
      <div className="contract-container">
        <div className="toggle-container">
          <Toggle
            id="contract-status-toggle"
            labelON="Active Contracts"
            labelOFF="All Contracts"
            onClick={handleToggleChange}
            toggled={showActiveOnly}
          />
        </div>
        {status.contractsLoading ? (
          <div
            style={{
              padding: "32px",
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Loader variant={LoaderSizes.large} />
          </div>
        ) : contractState.filteredServiceContract.length > 0 ? (
          <>
            {paginatedData.map((contract: (typeof contracts)[0]) => {
              return <ContractCard contract={contract} key={contract.ID} />;
            })}
            <Pagination
              currentPageNumber={currentPageNumber}
              totalRecords={totalRecords}
              pageSize={pageSize}
              border={true}
              onPageNumberClick={handlePageChange}
            />
          </>
        ) : (
          <div className="no-contract">
            <Iconography icon="cartShopping" size={IconographySizes.Medium} />
            <p>No Products Purchased</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default TabContentServiceContract;
